<template>
    <div class="placeBet" style="padding-bottom: calc(0.5rem + 10px);">
        <div class="placeBet-stake SingleSlip_Voucher_DropDown_Stake">
            <div
                class="placeBet-select-wrap"
            >
                <select v-model="voucherId">
                    <option
                        v-for="item in voucherList"
                        v-bind:key="item.id"
                        v-bind:value="item.id"
                        v-bind:disabled="!item.isAvailable"
                    >
                        {{ item.text }}
                    </option>
                </select>
            </div>
        </div>
        <button
            type="button"
            class="button JARVIS_BetTicket_Btn_PlaceBet"
            v-bind:class="{ _disable: isDisableBtn }"
            v-on:click="!isDisableBtn && $emit('placeVoucherBet')"
        >
            {{ i18n.t('placeBet_button_placeBet') }}
        </button>
    </div>
</template>

<script lang="ts">
    import type { PropType } from 'vue';
    import { computed, defineComponent, onUnmounted, ref, watch } from 'vue';
    import type { IVoucherDisplay } from '@/interface/voucher';
    import { i18n } from '@/libraries/i18n';

    export default defineComponent({
        name: 'PlaceVoucherBet',
        emits: ['placeVoucherBet', 'updateSelectedVoucher'],
        props: {
            currency: {
                type: String,
                default: '',
            },
            isDisableBtn: {
                type: Boolean,
                default: false,
            },
            voucherList: {
                type: Array as PropType<IVoucherDisplay[]>,
                default: () => [],
            },
        },
        setup(props, context) {
            const voucherId = ref('');
            const selectedVoucher = computed(() => props.voucherList.find(item => item.id === voucherId.value) ?? null);

            watch(selectedVoucher, () => {
                if (selectedVoucher.value) {
                    context.emit('updateSelectedVoucher', selectedVoucher.value);
                }
            }, { immediate: true });

            const validVouchers = props.voucherList.filter(item => item.isAvailable);
            if (validVouchers.length > 0) {
                voucherId.value = validVouchers[0].id;
            } else if (props.voucherList.length > 0) {
                voucherId.value = props.voucherList[0].id;
            }

            onUnmounted(() => {
                context.emit('updateSelectedVoucher', null);
            });

            return {
                i18n,
                voucherId,
                selectedVoucher,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @import "@/scss/components/placeBet";
</style>
